const originalConsoleError = console.error;
console.error = (...args) => {
  if (args[0].includes('A non-serializable value was detected')) {
    return; // Ignore the warning message
  }
  originalConsoleError(...args);
};